import { useEffect, useState } from "react";
import { useApiClient } from "../../../../shared/hooks";
function useLineOfCreatedReferrals(startDate: string, endDate?: string) {
  const apiClient = useApiClient();

  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [referralData, setReferralData] = useState<any>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        setIsError(false);
        const data = await apiClient.getReferralAnalyticsData(startDate, endDate);
        setReferralData(data);
      } catch (error) {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [startDate, endDate]);

  if (!referralData) {
    return {
      data: null,
      isLoading,
      isError,
    };
  }

  const data = {
    labels: referralData.created_referrals.data.map((item: any) => item.date),
    datasets: [
      {
        label: 'Daily Created Referrals',
        data: referralData.created_referrals.data.map((item: any) => item.count),
        fill: false,
        backgroundColor: '#1f77b4',
        borderColor: '#1f77b4',
        pointRadius: 1,
        borderWidth: 2,
      },
    ],
  };

  return {
    data,
    isLoading,
    isError,
    countBeforeStartDate: referralData.created_referrals.count_before_start_date
  };
}

export default useLineOfCreatedReferrals;
